import { render, staticRenderFns } from "./InvestmentFiles.vue?vue&type=template&id=0c66a154"
import script from "./InvestmentFiles.vue?vue&type=script&lang=js"
export * from "./InvestmentFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports